
//import { userService } from 'src/_services';
import axiosInstance from '../axios-orders';
import {authHeader} from '../_helpers';

export const fetchWrapper = {
    get,
    login,
    post,
    put,
    delete: _delete 
}

function get(url) {    
    return axiosInstance().get(url)
    .then(
        (result)=> {return result.data}); 
}
function login(username, password) {    
    const LOGIN_URL = '/api/identity/oauth/token';
    const passwordStr = `&password=${password}`;
    const params = `grant_type=password&username=${username}${passwordStr}`; 
    console.log(params); 
    return axiosInstance()
    .post(LOGIN_URL, params)
    .then(handleResponse)    
    .then(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user',JSON.stringify(user.firstName));
        localStorage.setItem('access_token',JSON.stringify(user.access_token));
        return user;
    });    
}
function post(url, body) {
    console.log(url);   
    return axiosInstance()
    .post(url,body)
    
        
}
function put(url, body) {    
    return axiosInstance()
    .post(url,body)
    .then(handleResponse);   
}
function _delete(url) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(url)
    };
    return fetch(url, requestOptions).then(handleResponse);
}
function handleResponse(response) {
    const data=response.data; 
    let error='';
    console.log(response);    
        if (!response.status===200) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                //logout();
                window.location.reload(true);
     }           
         if (response.status === 400) { 
             error='Usuario o Contraseña incorrectas';
     }
        if ( response.status === 500) {  error='Hubo un error en la conexion del servidor'; }
        if (!error.status) { error='Hubo un error en la conexion del servidor'; 
    }            //const error = (data && data.message) || response.statusText;           
            return Promise.reject(error);
        }

        return data;
    
}